export default __webpack_public_path__ + "static/media/processCycle.cde84641.png";